<template>
  <div v-if="item" class="border">
    <div v-if="!changeItem">
      <fields-list :simple="true" :item="item" :fields="fields" />
      <button class="btn btn-info mw" @click="updateItem">
        {{ button_key | setText() }}
      </button>
    </div>
    <div v-else>
      <fields-list
        @change="updateItem"
        :simple="true"
        :item="item"
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "clients",
    cardSetLink: "clients",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "passport_prefix",
        label: "Тип паспорта",
        labelKey: "passport_prefix",
        type: "static_radio",
        items: [
          { id: "id", title: "ИД Карта" },
          { id: "old", title: "Обычный паспорт" },
        ],
      },
      {
        col: " col-12 col-md-6",
        key: "passport_1",
        labelKey: "passport_1",
        label: "Главное фото паспорта или ID",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_3",
        labelKey: "passport_3",
        label: "Прописка или обратная сторона ID",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_4",
        labelKey: "passport_4",
        label: "Селфи с паспортом или ID",
        type: "img",
      },
    ],
  }),

  props: {
    changeItem: {
      default: false,
    },
    id: {
      default: null,
    },
    button_key: {
      default: "apply",
    },
    disablePinfl: {
      default: false,
    },
  },
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    if (!this.disablePinfl) {
      this.fields.push({
        col: " col-12 col-md-12",
        key: "PINFL",
        labelKey: "PINFL",
        label: "ПИНФЛ",
        type: "field",
        textType: "text",
      });
      this.fields.push({
        col: " col-12 col-md-12",
        key: "passport_number",
        labelKey: "passport_number",
        label: "Номер паспорта",
        type: "field",
        textType: "text",
      });
    }
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );

      if (item && item.id) {
        this.$emit("input", item);
      }
    },
  },
};
</script>
<style>
</style>
